import React, { useEffect, useState } from 'react';
import { useHistory, NavLink } from "react-router-dom";
import { State, City } from 'country-state-city';
import Select from 'react-select';
import axios from 'axios';
import { BASEURL } from "../Config";
import swal from 'sweetalert';
import MyDropzone from "../components/MyDropzone";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import '../assets/custom_select.css';

const AddSalesManager = (props) => {
  const history = useHistory();
  const { uuid } = props;
  const heading = uuid ? 'Edit Sales Manager' : 'Add Sales Manager';
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  const [pan, setPan] = useState("");
  const [address, setAddress] = useState("");
  const [selectedStatesArray, setSelectedStatesArray] = useState([]);
  const [selectedCitiesArray, setSelectedCitiesArray] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [pinCode, setPinCode] = useState("");

  // Errors
  const [firstNameError, setFirstNameError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [profilePicError, setProfilePicError] = useState(false);
  const [aadhaarError, setAadhaarError] = useState(false);
  const [panError, setPanError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [cityError, setCityError] = useState(false);

  useEffect(() => {
    const states = State.getStatesOfCountry('IN').map(state => { return { label: state.name, value: state.isoCode } });
    setStates(states);
    if (uuid) { fetchSalesManager() }
  }, []);

  const fetchSalesManager = () => {
    axios.get(`${BASEURL}/api/v1/salesManager/${uuid}`)
      .then(res => {
        const data = res.data;
        setFirstName(data.firstName);
        setLastName(data.lastName);
        setPhoneNumber(data.phoneNo);
        setEmail(data.emailID);
        setUsername(data.username);
        setPassword(data.password);
        setProfilePic(data.profilePic);
        setAadhaar(data.aadhaar);
        setPan(data.pan);
        setAddress(data.address);
        setSelectedStatesArray(data.states);
        // set cities
        data.states.forEach(option => {
          const citiesOfState = City.getCitiesOfState('IN', option.value);
          cities.push(...citiesOfState.map(city => ({ label: city.name, value: city.name })));
        });
        setCities(cities);
        setSelectedCitiesArray(data.cities);
      })
      .catch(err => {
        console.log("Fetch salesManager error", err);
        swal('Error', 'Failed to fetch Sales Manager details', 'error');
      });
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "firstName") {
      setFirstName(value);
    } else if (name === "lastName") {
      setLastName(value);
    } else if (name === "phoneNumber") {
      setPhoneNumber(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "username") {
      setUsername(value);
    } else if (name === "password") {
      setPassword(value);
    } else if (name === "address") {
      setAddress(value);
    } else if (name === "pinCode") {
      setPinCode(value);
    }
  };

  const handleStateChange = selectedOptions => {
    setSelectedStatesArray(selectedOptions);
    let cities = [];
    selectedOptions.forEach(option => {
      const citiesOfState = City.getCitiesOfState('IN', option.value);
      cities.push(...citiesOfState.map(city => ({ label: city.name, value: city.name })));
    });
    setCities(cities);
  };

  const handleCityChange = selectedOptions => {
    setSelectedCitiesArray(selectedOptions);
  };

  const validateData = () => {
    let error = false;
    if (firstName === "" || firstName === undefined) {
      setFirstNameError(true);
      error = true;
    }
    if (phoneNumber === "" || phoneNumber === undefined) {
      setPhoneNumberError(true);
      error = true;
    }
    if (email === "" || email === undefined) {
      setEmailError(true);
      error = true;
    }
    if (username === "" || username === undefined) {
      setUsernameError(true);
      error = true;
    }
    if (password === "" || password === undefined) {
      setPasswordError(true);
      error = true;
    }
    if (profilePic === "" || profilePic === undefined) {
      setProfilePicError(true);
      error = true;
    }
    if (aadhaar === "" || aadhaar === undefined) {
      setAadhaarError(true);
      error = true;
    }
    if (pan === "" || pan === undefined) {
      setPanError(true);
      error = true;
    }
    if (address === "" || address === undefined) {
      setAddressError(true);
      error = true;
    }
    if (selectedStatesArray.length === 0) {
      setStateError(true);
      error = true;
    }
    if (selectedCitiesArray.length === 0) {
      setCityError(true);
      error = true;
    }
    return error;
  };

  const handleSubmit = () => {
    let validationError = validateData();
    if (validationError) {
      swal('Error in Creating Sales Manager', 'Fill the required fields', 'error');
    } else {
      const inputObj = {
        firstName: firstName,
        lastName: lastName,
        phoneNo: phoneNumber,
        emailID: email,
        username: username,
        password: password,
        profilePic: profilePic,
        aadhaar: aadhaar,
        pan: pan,
        address: address,
        states: selectedStatesArray,
        cities: selectedCitiesArray
      };
      if (uuid) {
        axios.put(`${BASEURL}/api/v1/salesManager/${uuid}`, inputObj)
          .then(res => {
            if (res.status === 200) {
              swal("Success", "Sales Manager Updated successfully", "success")
                // .then(function () {
                //   window.location = "salesManagers";
                // })
            }
          })
          .catch((err) => {
            swal('Error in Updating Sales Manager', err.response.data, 'error');
            console.log('Update Sales Manager Error', err);
          })
      } else {
        axios.post(`${BASEURL}/api/v1/salesManager`, inputObj)
          .then(res => {
            if (res.status === 200) {
              swal("Success", "Sales Manager Created successfully", "success")
                .then(function () {
                  window.location = "salesManagers";
                })
            }
          })
          .catch((err) => {
            swal('Error in Creating Sales Manager', err.response.data, 'error');
            console.log('Create Sales Manager Error', err);
          })
      }
    }
  }

  const cardData = () => {
    return <div className="card main-card">
      <div className="card-body">
        <div className="row">
          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="firstName" className="form-label">First Name *</label>
              <input type="text" id="firstName" className="form-control" onChange={handleChange}
                name="firstName" placeholder="Enter First Name" value={firstName} />
              {firstNameError ? <p className="errTxt">First Name is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="lastName" className="form-label">Last Name</label>
              <input type="text" id="lastName" className="form-control" onChange={handleChange}
                name="lastName" placeholder="Enter Last Name" value={lastName} />
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="phoneNumber" className="form-label">Phone Number *</label>
              <input type="text" id="phoneNumber" className="form-control" onChange={handleChange}
                name="phoneNumber" placeholder="Enter Phone Number" value={phoneNumber} />
              {phoneNumberError ? <p className="errTxt">Phone Number is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email ID *</label>
              <input type="email" id="email" className="form-control" onChange={handleChange}
                name="email" placeholder="Enter Email ID" value={email} />
              {emailError ? <p className="errTxt">Email ID is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="username" className="form-label">Username *</label>
              <input type="text" id="username" className="form-control" onChange={handleChange}
                name="username" placeholder="Enter Username" value={username} />
              {usernameError ? <p className="errTxt">Username is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password *</label>
              <input type={uuid ? "text" : "password"} id="password" className="form-control" onChange={handleChange}
                name="password" placeholder="Enter Password" value={password} />
              {passwordError ? <p className="errTxt">Password is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label>Upload Profile Pic *</label>
              <MyDropzone file={profilePic} setFile={setProfilePic} setError={setProfilePicError} fromPage="addSalesManagerPage" />
              {profilePicError ? <p className="errTxt">Profile Pic is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label>Upload Aadhaar *</label>
              <MyDropzone file={aadhaar} setFile={setAadhaar} setError={setAadhaarError} fromPage="addSalesManagerPage" />
              {aadhaarError ? <p className="errTxt">Aadhaar is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label>Upload PAN *</label>
              <MyDropzone file={pan} setFile={setPan} setError={setPanError} fromPage="addSalesManagerPage" />
              {panError ? <p className="errTxt">PAN is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-12 col-sm-12">
            <div className="mb-3">
              <label htmlFor="address" className="form-label">Address *</label>
              <textarea id="address" className="form-control" onChange={handleChange}
                name="address" placeholder="Enter Address" value={address} />
              {addressError ? <p className="errTxt">Address is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="state" className="form-label">Assign States *</label>
              <Select
                name="state"
                isMulti
                options={states}
                value={selectedStatesArray}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleStateChange}
              />
              {stateError ? <p className="errTxt">State is Required</p> : ''}
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <label htmlFor="city" className="form-label">Assign Cities *</label>
              <Select
                name="city"
                isMulti
                options={cities}
                value={selectedCitiesArray}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleCityChange}
              />
              {cityError ? <p className="errTxt">City is Required</p> : ''}
            </div>
          </div>

          {/* <div className="col-md-4 col-sm-12">
          <div className="mb-3">
            <label htmlFor="pinCode" className="form-label">Pin Code *</label>
            <input type="number" id="pinCode" className="form-control" onChange={handleChange}
              name="pinCode" placeholder="Enter Pin Code" value={pinCode} />
            {pinCodeError ? <p className="errTxt">Pin Code is Required</p> : ''}
          </div>
        </div> */}
        </div>

        <div className="mb-2 d-flex">
          <button type="submit" className="btn btn-customprimary" onClick={handleSubmit}>{uuid ? 'Update' : 'Create'}</button>
          <button type="button" style={{ color: '#6c757d' }} className="btn" onClick={() => { history.push('/salesManagers') }}>Cancel</button>
        </div>
        {/* end row */}
      </div> {/* end card-body */}
    </div>
  }

  // if (uuid) {
  //   return cardData();
  // }


  return (
    <div id="wrapper">
      <Sidebar act="salesManagers" />
      {/* Content Wrapper */}
      <div className="content-page">
        {/* Main Content */}
        <div className="content">
          <Topbar act={heading} breadcrumbItems={['Sales App', { label: 'Sales Managers', path: '/salesManagers' }, `${heading}`]} />
          {/* container */}
          {/* content */}
          <div className="container-fluid main-container">
            {cardData()}
            {/* end card*/}
          </div>
          {/* End of Main Content */}
          <Footer />
        </div>
        {/* End of Content Wrapper */}
      </div>
    </div>
  );
}

export default AddSalesManager;
